import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      Subdomain Manage is active
    </div>
  );
}

export default App;
